import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    appointmentId: String,
    invoiceId: String
  }

  resendEmail(event) {
    if (!confirm('¿Está seguro que desea reenviar la factura por email al paciente?')) {
      return;
    }

    const button = event.currentTarget;
    const btnText = button.querySelector('.btn-text');
    const spinner = button.querySelector('.spinner-border');
    const icon = button.querySelector('i');

    // Mostrar spinner y deshabilitar botón
    button.disabled = true;
    button.style.cursor = 'not-allowed';
    button.style.opacity = '0.6';
    btnText.textContent = 'Enviando...';
    spinner.classList.remove('d-none');
    icon.style.display = 'none';

    // Crear y enviar el formulario
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `/appointments/${this.appointmentIdValue}/resend_invoice_email?invoice_id=${this.invoiceIdValue}`;

    // Agregar CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    // Agregar al DOM, enviar y remover
    document.body.appendChild(form);
    form.submit();
  }
}
